import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { FocusableTooltip } from "../../../../../components/FocusableTooltip";
import { formatCurrency } from "../../../../../utils";
import { cashbackNotesOf, cashbackSplitOf } from "./utils";
import {
  InfoButton,
  InfoContent,
  InfoLine,
  InfoLineNote,
  InfoSplit,
  InfoText,
} from "./styles";
import { CashbackInfoProps } from "./types";

export const CashbackInfo: React.FC<CashbackInfoProps> = ({
  caption,
  summary,
  mode,
}) => {
  const split = cashbackSplitOf(summary);
  const notes = cashbackNotesOf(summary, mode);

  const content = (
    <InfoContent data-testid="saving-cashback-info">
      <InfoText>{caption}</InfoText>
      {split.length > 0 && (
        <InfoSplit>
          {split.map((line) => (
            <InfoLine key={line.id} data-testid={`cashback-split-${line.id}`}>
              <span>{line.label}</span>
              <strong>{formatCurrency(line.amount)}</strong>
              {line.note && <InfoLineNote>{line.note}</InfoLineNote>}
            </InfoLine>
          ))}
        </InfoSplit>
      )}
      {notes.map((note) => (
        <InfoText key={note} data-testid="cashback-note">
          {note}
        </InfoText>
      ))}
    </InfoContent>
  );

  return (
    <FocusableTooltip title={content}>
      <InfoButton type="button" aria-label="About this cashback">
        <InfoOutlinedIcon fontSize="inherit" />
      </InfoButton>
    </FocusableTooltip>
  );
};
